import React, {useEffect, useState} from 'react';
import s from './App.module.css';
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PersonalAccount from "./pages/PersonalAccount/PersonalAccount";
import Accounts from "./pages/PersonalAccount/Accounts/Accounts";
import Transfers from "./pages/PersonalAccount/Transfers/Transfers";
import Currency from "./pages/PersonalAccount/Currency/Currency";
import LoginizationSteps from "./pages/LoginizationSteps/LoginizationSteps";
import Templates from "./pages/PersonalAccount/Templates/Templates";
import SettingsPersonal from "./pages/PersonalAccount/SettingsPersonal/Settings/Settings";
import SettingsBusiness from "./pages/PersonalAccount/SettingsBusiness/Settings/Settings";
import Security from "./pages/PersonalAccount/Security/Security";
import CreateTemplate from "./pages/PersonalAccount/Templates/CreateTemplate/CreateTemplate";
import { useAppDispatch, useAppSelector } from "./hooks/redux";
import { userSlice } from "./store/reducers/UserSlice";
import Home from "./pages/PublicPages/Home/Home";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { publicRoutes } from "./Constants/PublicRoutes";
import MobileHeader from "./components/MobileHeader/MobileHeader";
import PersonalAccountHeader from "./components/PersonalAccountHeader/PersonalAccountHeader";
import RegistrationSteps from "./pages/RegistrationSteps/RegistrationSteps";

function App() {

    const {pathname} = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const dispatch = useAppDispatch()
    const setDisabled = userSlice.actions.setDisabled
    const user = useAppSelector(state => state.userReducer.user.userToken)

    useEffect(() => {
        dispatch(setDisabled(false))
        localStorage.clear()
    }, [])

    useEffect(() => {
        if (pathname.includes("personal_account")) {
            setIsLoggedIn(true)
        } else {
            setIsLoggedIn(false)
        }
    }, [pathname])

    const ProtectedRoute = (props: any) => {
        if (!props.user) {
            return <Navigate to={props.redirectPath} replace/>;
        }
        return props.children;
    };

    return (
        <div className={s.app}>

            {
                isLoggedIn ? <div className=""></div>  
                : <div className={
                    pathname === '/'
                    ? s.header_home
                    : s.desktop_header 
                }>
                    <Header/>
                </div>
            }
            

            {
                isLoggedIn ? <div className={s.mobile_header}>
                    <PersonalAccountHeader/>
                </div> : <div className={
                    pathname === '/'
                    ? s.mobile_header_home 
                    : s.mobile_header
                }>
                    <MobileHeader/>
                </div>
            }

            <Routes>
                <Route path={'/'} element={<Home/>}/>

                {
                    publicRoutes.map((route) => {
                        return (
                            <Route path={route.path} element={route.element}/>
                        )
                    })
                }

                <Route path={'/sign-in'} element={<LoginizationSteps/>}/>
                <Route path={'/sign_up'} element={<RegistrationSteps/>}/>

                <Route path={'/personal_account'} element={
                    <ProtectedRoute redirectPath={'/sign-in'} user={user}>
                        <PersonalAccount/>
                     </ProtectedRoute>
                }>
                    <Route path={"accounts"} element={<Accounts/>}/>
                    <Route path={'templates'}>
                        <Route index element={<Templates/>}/>
                        <Route path={"new-template/:id/:type"} element={<CreateTemplate/>}/>
                    </Route>
                    <Route path={'transfers'} element={<Transfers/>}/>
                    <Route path={'currency'} element={<Currency/>}/>
                    <Route path={'security'} element={<Security/>}/>

                    <Route path={'personal'}>
                        <Route path={'settings'} element={<SettingsPersonal/>}/>
                    </Route>

                    <Route path={'business'}>
                        <Route path={'settings'} element={<SettingsBusiness/>}/>
                    </Route>
                </Route>
            </Routes>
            <Footer/>
        </div>
    );
}

export default App;
